import React from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import CircularProgress from "@mui/material/CircularProgress";
import RefreshButton from "../../core/RefreshButton";
import { useForm } from "react-hook-form";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300,
    },
    selectBox: {
        width: "100%",
    },
}));

export const listInitializer = (
    apiFunction,
    formatFunction,
    setDataFunction,
    setErrorWithTimeout,
    listName,
    setIsLoading
) => {
    return async (...args) => {
        try {
            if (setIsLoading) {
                setIsLoading(true);
            }
            const response = await apiFunction(...args);
            if (formatFunction) {
                response.data = formatFunction(response.data);
            }
            setDataFunction(response.data);
        } catch (error) {
            const errorMessage = error?.message || String(error);
            console.error(`There was an error initializing the ${listName}, ${errorMessage}`);
            setErrorWithTimeout(`Failed to initialize the ${listName}: ${errorMessage}`, 10000);
        } finally {
            if (setIsLoading) {
                setIsLoading(false);
            }
        }
    };
};

export const Dropdown = ({
    dropdownName,
    dropdownValue,
    setValue,
    setValueName,
    options,
    formRegisterName,
    disabledCondition,
    refreshDisabled,
    refreshFunction,
    sortFunction,
    isDataLoading,
}) => {
    const classes = useStyles();
    const { register } = useForm();

    const displayOptions = sortFunction ? [...options].sort(sortFunction) : [...options];

    return (
        <FormControl className={classes.formControl}>
            <InputLabel id={`${dropdownName.toLowerCase()}-label`}>{dropdownName}</InputLabel>
            <Select
                {...register(formRegisterName ? formRegisterName : dropdownName.toLowerCase())}
                labelId={`${dropdownName.toLowerCase()}-label`}
                value={dropdownValue || ""}
                label={dropdownName}
                onChange={(e) => setValue(setValueName ? setValueName : dropdownName.toLowerCase(), e.target.value)}
                disabled={disabledCondition}
                className={classes.selectBox}
            >
                <MenuItem value="" disabled>
                    {`Select a ${dropdownName.toLowerCase()}...`}
                </MenuItem>
                {displayOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label ? option.label : option.value}
                    </MenuItem>
                ))}
            </Select>
            {!refreshDisabled && (
                <RefreshButton
                    onClickFunction={refreshFunction}
                    setValue={setValue}
                    valueName={setValueName ? setValueName : dropdownName.toLowerCase()}
                    disabledBoolean={disabledCondition}
                    ariaLabel={`refresh ${dropdownName.toLowerCase()}`}
                />
            )}
            {isDataLoading && <CircularProgress style={{ marginLeft: "40px" }} />}
        </FormControl>
    );
};
